
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.card-variant-btn');
  if (!btn) return;

  const card = btn.closest('.card-wrapper');
  if (!card) return;

  const variantId = btn.dataset.variantId;

  // Update product URL with variant
  const link = card.querySelector('a.full-unstyled-link');
  if (link) {
    const baseUrl = link.href.split('?')[0];
    link.href = baseUrl + '?variant=' + variantId;
  }

  // Active state
  btn.parentElement.querySelectorAll('.card-variant-btn')
    .forEach(b => b.classList.remove('is-active'));
  btn.classList.add('is-active');
});








